import { useEffect, useState } from "react";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../theme/Component/Modal";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _CashRequestItem, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { FileService } from "../../../../../core/services/FileService";
import { FileInput } from "../../../../theme/Component/FileInput";
import { InputMoney } from "../../../../theme/Input/InputMoney";
import { SeeInvoice } from "../../CashResquestItems/SeeInovoice";
import { toast } from "react-toastify";
import { SelectBusinessCore } from "../../BusinessCore/SelectBusinessCore";
import { SelectProject } from "../../BudgetAccountantOperation/SelectProject";
import { InputDate } from "../../../../theme/Input/InputDate";
import useModal, { MODAL_md, MODAL_XL } from "../../../../theme/Component/hooks/useModal";

interface Props {
    formData: any;
    onChange: Function;
    response: any;
}

export const CreateRequestCashItems = ({ onChange, formData, response }: Props) => {

    const { lista, setLista, bean, setBean, instance, handleChange } = useDataBean(_CashRequestItem);
    const file = new FileService();

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-xl", });
    const [modalConfirm, setModalConfirm] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-sm", });
    const [modalSeeInvoice, setModalSeeInvoice] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const modalDoc = useModal("Documento Soporte", MODAL_XL);

    useEffect(() => {
        if (onChange && lista.length > 0) {
            onChange(lista)
        }
    }, [lista.length])

    useEffect(() => {
        if (response?.IDCashRequest) {
            getLista()
        }
    }, [response])

    const listaBotones = () => {
        const botones = [
            { titulo: "Ver Documento Soporte", icono: "ri-eye-line", visible: true, evento: () => { modalDoc.open(); }, },
            { titulo: "Eliminar", icono: "ri-delete-bin-line", visible: (true), evento: () => { setModalConfirm({ ...modalConfirm, view: true, name: `Eliminar ${bean.Description}` }); }, },
            { titulo: "Ver Factura Electronica", icono: "ri-eye-line", visible: bean.IDUBLInvoice, evento: () => { setModalSeeInvoice({ ...modalSeeInvoice, view: true, name: `Factura Asociada al Item ${bean.Description}` }); }, },
        ];
        return <ListMenu listaBotones={botones} />;
    };

    const getLista = () => {
        instance.getCashRequestItemCatalog(response.IDCashRequest, response.CashRequestDate).then(
            (resp) => {
                let x = resp;
                x.forEach(element => {
                    if (element.DataBeanProperties.Media) {
                        const doc = file.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media);
                        element.DataBeanProperties.EntityMedia = "<a target='_blank' href='" + doc + "'>" + element.DataBeanProperties.Media + "</a>";
                    } else {
                        element.DataBeanProperties.EntityMedia = "Sin Adjunto"
                    }
                });
                setLista(x)
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }

    const eliminarItem = () => {
        instance.deleteCashRequestItem(bean.IDCashRequestItem, _single.getCurrenDate(), _single.getAccountID()).then(
            (resp) => {
                setModalConfirm({ ...modalConfirm, "view": false });
                getLista();
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDCashRequestItem' },
        { title: 'Descripción', property: 'Description' },
        { title: 'Archivo de Factura/Solicitud', property: 'EntityMedia' },
        { title: 'Valor Solicitado', property: 'PaymentValue' },
        { title: 'Proveedor', property: 'IDAccountSupplier' },
        { title: '¿Es Factura Electrónica?', property: 'IsUBLDocument' },
        { title: 'Factura Electrónica', property: 'InvoiceName' },
        { title: 'Respuesta de la Caja', property: 'CashResponse' },
        { title: 'Responsable de Caja', property: 'EmployeeName' },
        { title: 'Documento de Rembolso', property: 'AdvanceDocumentConsecutive' },
    ]

    const createItem = () => {
        setBean({
            IDCashRequest: formData.ResponseService.IDCashRequest,
            CashRequestDate: formData.ResponseService.CashRequestDate,
        });
        setModal({ ...modal, "view": true, "name": "Crear una Solicitud de Pago" })
    }

    const iconButtonsItem = [
        { nombre: "Agregar Factura", visible: (true), icono: "ri-file-add-line", evento: createItem },
    ];

    const createItemRequest = () => {
        instance.importUBLInvoiceToCashRequest(bean.IDCashRequest, bean.CashRequestDate, bean.Media, bean.MediaContext, null, bean.IssueDate, bean.InvoiceID, bean.PaymentValue, bean.Observations, bean.IDProject, bean.IDBusinessCore).then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(
            err => {
                console.error(err);
            }
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            createItemRequest();
        }
    }

    const validateForm = () => {
        const requiredFieldsCash = [
            "Media", "IssueDate", "InvoiceID", "PaymentValue", "Observations", "IDProject", "IDBusinessCore"
        ];
        let missing = [];
        for (let field of requiredFieldsCash) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }

        setMissingFields(missing);
        return missing.length
    };

    const [fileType, setFileType] = useState<string>(null);
    const [donwloadURL, setDonwloadURL] = useState<string>(null);
    const [urlFile, setUrlFile] = useState<string | null>(null);

    useEffect(() => {
        if (donwloadURL) {
            const fetchPdf = async () => {
                try {
                    const data = await file.getPdfAsBase642(donwloadURL);
                    setUrlFile(data);
                } catch (error) {
                    console.error('Error loading PDF:', error);
                }
            };

            fetchPdf();
        }
    }, [donwloadURL]);

    useEffect(() => {
        setFileType(bean.Media?.split('.').pop())
        setDonwloadURL(file.getUrlFile(bean.MediaContext, bean.Media))
    }, [bean])

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} body={lista} head={head} rowSet={setBean} />
            </div>

            <div className="col-md-12">
                <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                    {bean.Description}
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData(); }} onSubmitLabel={`guardar`}>
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Media') ? 'has-error' : ''}`}>Archivo a importar</label>
                            <FileInput
                                Media={bean.Media}
                                MediaContext={bean.MediaContext}
                                label=" "
                                onCreate={(e: any) => setBean({ ...bean, 'Media': e.Media, 'MediaContext': e.MediaContext })}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IssueDate') ? 'has-error' : ''}`}>Fecha de la Factura</label>
                            <InputDate name="" value={bean.IssueDate} notDate setDate={(e) => { setBean({ ...bean, IssueDate: e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('InvoiceID') ? 'has-error' : ''}`}>Número de Factura</label>
                            <input type="text" className="form-control" value={bean.InvoiceID} onChange={(e) => { setBean({ ...bean, InvoiceID: e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('PaymentValue') ? 'has-error' : ''}`}>Valor Solicitado</label>
                            <InputMoney _label=" " _value={bean.PaymentValue} onChange={(e) => { setBean({ ...bean, "PaymentValue": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDProject') ? 'has-error' : ''}`}>Proyecto</label>
                            <SelectProject
                                label=" "
                                idSelector={bean.IDProject}
                                onChange={(value) => {
                                    if (!value) {
                                        setBean({
                                            ...bean,
                                            IDProject: null,
                                            IDBusinessCore: null
                                        });
                                        return;
                                    }

                                    const { IDProject, IDBusinessCore } = value;
                                    setBean({
                                        ...bean,
                                        IDProject: IDProject ?? null,
                                        IDBusinessCore: IDBusinessCore ?? null
                                    });
                                }}
                                returnType="Object"
                            />

                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDBusinessCore') ? 'has-error' : ''}`}>Core de Negocio</label>
                            <SelectBusinessCore label=" " idSelector={bean.IDBusinessCore} onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e }) }} />
                        </div>
                        <div className="col-12">
                            <label className={`${missingFields.includes('Observations') ? 'has-error' : ''}`}>Observaciones</label>
                            <textarea value={bean.Observations} name="Observations" className="form-control" onChange={handleChange} rows={4} />
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalSeeInvoice} updateModal={setModalSeeInvoice} >
                    <>
                        <SeeInvoice idInvoice={bean.IDUBLInvoice} issueDate={bean.IssueDate} />
                    </>
                </Modal>
            </div>

            <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal} >
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="iframe-container">

                                {fileType ?
                                    <>
                                        {fileType === 'pdf' && (
                                            urlFile ? (
                                                <>
                                                    aqui
                                                    <iframe name="pdfviwer" src={urlFile} onError={(e) => console.error('Error loading PDF:', e)}></iframe>
                                                </>
                                            ) : (
                                                <p>Cargando PDF...</p>
                                            )
                                        )}
                                        {fileType === `"jpg"` || fileType === "png" &&
                                            (
                                                <img src={urlFile} alt="Image Preview" width="100%" />
                                            )
                                        }
                                        {fileType !== "pdf" && "jpg" && "png" &&
                                            <>
                                                <a href={donwloadURL} target='_blank'>Clic aquí para descargar el archivo {bean.Media}</a>
                                            </>
                                        }
                                    </>
                                    :
                                    <>
                                        No se pudo cargar el Documento
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Modal >
        </div>
    )
}